// import PropTypes from 'prop-types'
import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { Switch, Route } from 'react-router-dom';
import Home from '../src/pages/Home';
import Details from './pages/Details';
import AnimateOnScroll from 'react-global-animate-on-scroll';

import './styles/App.css';

export default class App extends Component {

  render() {
    return (
      <Switch>
        <Route exact path='/' component={ Home } />
        <Route exact path='/:id' component={ Details } />
        <AnimateOnScroll animateOnce />
      </Switch>
    )
  };
};
